/* RYTM Bundle PDP Buy Box behaviour. Vanilla JS, no dependencies, safe for multiple instances per page. */
(function () {
  'use strict';

  function initGallery(root) {
    var groups = Array.prototype.slice.call(root.querySelectorAll('.rytm-buybox__image-group'));

    groups.forEach(function (group) {
      var images = Array.prototype.slice.call(group.querySelectorAll('.rytm-buybox__image'));
      var dots = Array.prototype.slice.call(group.querySelectorAll('.rytm-buybox__image-dot'));
      if (images.length < 2) return;

      function currentIndex() {
        for (var i = 0; i < images.length; i++) {
          if (images[i].classList.contains('is-active')) return i;
        }
        return 0;
      }

      function setActive(index) {
        images.forEach(function (img, i) {
          img.classList.toggle('is-active', i === index);
        });
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === index);
        });
      }

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () { setActive(i); });
      });

      var prevBtn = group.querySelector('.rytm-buybox__image-arrow--prev');
      var nextBtn = group.querySelector('.rytm-buybox__image-arrow--next');

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          var i = currentIndex();
          setActive(i === 0 ? images.length - 1 : i - 1);
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          var i = currentIndex();
          setActive(i === images.length - 1 ? 0 : i + 1);
        });
      }
    });
  }

  function initAccordion(root) {
    var triggers = Array.prototype.slice.call(root.querySelectorAll('.rytm-buybox__collapsible-trigger'));

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var expanded = trigger.getAttribute('aria-expanded') === 'true';
        trigger.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      });
    });
  }

  /* ---------- Cart ----------

     Self-contained AJAX add-to-cart. Deliberately NOT wired to the theme's
     <product-form-component>: that routes the add through Horizon's own
     validation and changes how out-of-stock is handled. This posts the exact
     same body the plain form was already posting, and then IGNORES the
     response — success or failure — so add-to-cart behaves exactly as it did
     with the plain form POST. The only difference is that we stay on the page
     and open the cart drawer instead of letting the browser navigate to /cart.

     Do not add error handling here: surfacing the response is precisely the
     behaviour change we're avoiding. */

  function cartSectionIds() {
    // Discovered from the DOM, never hardcoded. cart-items-component publishes
    // its own section id; the header badge lives in a different section, found
    // via the <cart-icon> element's shopify-section wrapper.
    var ids = [];

    function push(id) {
      if (id && ids.indexOf(id) === -1) ids.push(id);
    }

    var items = document.querySelector('cart-items-component');
    if (items) push(items.dataset.sectionId);

    var icon = document.querySelector('cart-icon');
    var wrapper = icon && icon.closest ? icon.closest('[id^="shopify-section-"]') : null;
    if (wrapper) push(wrapper.id.replace('shopify-section-', ''));

    return ids;
  }

  function applySections(sections) {
    // Shopify returns each requested section as a full HTML string. Swapping
    // the inner HTML re-creates the custom elements inside, which re-upgrade
    // themselves on insertion.
    if (!sections) return false;

    var applied = false;

    Object.keys(sections).forEach(function (id) {
      var html = sections[id];
      if (typeof html !== 'string') return;

      var current = document.getElementById('shopify-section-' + id);
      if (!current) return;

      var fresh = new DOMParser()
        .parseFromString(html, 'text/html')
        .getElementById('shopify-section-' + id);
      if (!fresh) return;

      current.innerHTML = fresh.innerHTML;
      applied = true;
    });

    return applied;
  }

  function refreshCartData() {
    var items = document.querySelector('cart-items-component');
    if (items && typeof items.fetchCartData === 'function') {
      try { items.fetchCartData(); } catch (err) { /* ignore */ }
    }
  }

  function openCartDrawer() {
    // Horizon's drawer is <theme-drawer id="cart-drawer"> and exposes open().
    // Re-queried on every call because applySections() may have replaced it.
    var drawer = document.getElementById('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return true;
    }

    // Fallback: click the cart icon, the same way a shopper would.
    var icon = document.querySelector('cart-icon, .header-actions__cart-icon');
    if (icon) {
      (icon.closest('a, button, [role="button"]') || icon).click();
      return true;
    }

    return false;
  }

  function initCart(root) {
    var form = root.querySelector('.rytm-buybox__form');
    if (!form) return;

    var submitting = false;

    form.addEventListener('submit', function (event) {
      // Without JS this listener never runs and the form posts normally, so
      // the section still works with scripts disabled.
      event.preventDefault();
      if (submitting) return;
      submitting = true;

      var button = form.querySelector('.rytm-buybox__cta');
      if (button) button.disabled = true;

      // FormData(form) reproduces the original POST body; `sections` asks
      // Shopify to return refreshed markup for the cart drawer and header.
      var body = new FormData(form);
      var sectionIds = cartSectionIds();
      if (sectionIds.length) {
        body.append('sections', sectionIds.join(','));
        body.append('sections_url', window.location.pathname);
      }

      fetch('/cart/add.js', {
        method: 'POST',
        body: body,
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' }
      })
        .then(function (response) { return response.json(); })
        // Only `sections` is ever read. Status and message are deliberately
        // ignored: a refused add leaves the cart markup untouched and the
        // drawer simply opens on the existing cart, which is what the plain
        // form POST effectively did.
        .then(function (data) { return applySections(data && data.sections); })
        .catch(function () { return false; })
        .then(function (applied) {
          if (!applied) refreshCartData();
          // Let the re-inserted custom elements upgrade before opening.
          setTimeout(openCartDrawer, 0);
          submitting = false;
          if (button) button.disabled = false;
        });
    });
  }

  function initInstance(root) {
    if (root.dataset.rytmBuyboxInit === 'true') return;
    root.dataset.rytmBuyboxInit = 'true';

    var radios = Array.prototype.slice.call(root.querySelectorAll('.rytm-buybox__radio'));
    var variantInput = root.querySelector('[data-rytm-buybox-variant-input]');
    if (!radios.length || !variantInput) return;

    function applySelection(radio) {
      root.setAttribute('data-selected', radio.dataset.image);
      variantInput.value = radio.dataset.variantId;
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (radio.checked) applySelection(radio);
      });
    });

    var checked = radios.filter(function (radio) { return radio.checked; })[0] || radios[0];
    if (checked) applySelection(checked);

    initGallery(root);
    initAccordion(root);
    initCart(root);
  }

  function initAll(context) {
    var scope = context || document;
    var instances = [];

    if (scope.matches && scope.matches('[data-rytm-buybox]')) {
      instances.push(scope);
    }
    if (scope.querySelectorAll) {
      Array.prototype.forEach.call(scope.querySelectorAll('[data-rytm-buybox]'), function (el) {
        instances.push(el);
      });
    }

    instances.forEach(initInstance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  // Re-init when a merchant adds/reorders this section in the theme editor.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();